import script from "./filters.vue?vue&type=script&setup=true&lang=ts"
export * from "./filters.vue?vue&type=script&setup=true&lang=ts"

import "./filters.vue?vue&type=style&index=0&id=3c35f74e&lang=postcss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3c35f74e"]])

export default __exports__